module.exports = __webpack_public_path__ + "img/168.7fd29980.jpg";